import React from 'react';
import { Check, X } from 'lucide-react';
import styles from './PasswordRequirements.module.css';

export interface PasswordValidationView {
  strength: string;
  checks: {
    length: boolean;
    uppercase: boolean;
    lowercase: boolean;
    number: boolean;
    special: boolean;
  };
}

interface PasswordRequirementsProps {
  validation: PasswordValidationView;
}

const REQUIREMENTS: Array<[keyof PasswordValidationView['checks'], string]> = [
  ['length', '8+ caracteres'],
  ['uppercase', 'Maiúscula'],
  ['lowercase', 'Minúscula'],
  ['number', 'Número'],
  ['special', 'Símbolo'],
];

const PasswordRequirements: React.FC<PasswordRequirementsProps> = ({ validation }) => (
  <div className={styles.root} aria-label="Requisitos da password">
    <div className={styles.strengthRow}>
      <span>Password</span>
      <strong className={styles[validation.strength] || styles.weak}>
        {validation.strength === 'strong' ? 'Forte' : validation.strength === 'medium' ? 'Média' : 'A melhorar'}
      </strong>
    </div>
    <div className={styles.bar} aria-hidden="true">
      <span className={`${styles.fill} ${styles[validation.strength] || styles.weak}`} />
    </div>
    <div className={styles.items}>
      {REQUIREMENTS.map(([key, label]) => {
        const passed = validation.checks[key];
        return (
          <span key={key} className={passed ? styles.passed : ''}>
            {passed ? <Check size={13} /> : <X size={13} />} {label}
          </span>
        );
      })}
    </div>
  </div>
);

export default PasswordRequirements;
